export interface Patient {
  id: string;              // from username
  username: string;
  firstName: string;       // from name.first_name
  lastName: string;        // from name.last_name
  middleName?: string;     // from name.middle_name
  dateOfBirth?: string;    // from birthday
  apiToken?: string;
  activities: unknown[];   // from activities array
  totalActivities: number; // calculated from activities.length
  status: PatientStatus;   // derived
}

export type PatientStatus = 'active' | 'inactive' | 'pending';

export interface PatientSummary {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  totalActivities: number;
  status: PatientStatus;
}

export interface PatientListResponse {
  patients: Patient[];
  total: number;
  page: number;
  pageSize: number;
}

export interface PatientFilters {
  search?: string;
  status?: PatientStatus;
}

export function getPatientFullName(patient: Patient | PatientSummary): string {
  return `${patient.firstName} ${patient.lastName}`.trim();
}

export function getPatientInitials(patient: Patient | PatientSummary): string {
  const first = patient.firstName.charAt(0).toUpperCase();
  const last = patient.lastName.charAt(0).toUpperCase();
  return `${first}${last}`;
}
